import { defineStore } from 'pinia';
import $http from '@nuxt-common/util/app/utils/http';

const SPONSORED_ITEMS_URL = '/sitemonetization/v1/sponsored-products/sm-deals-desktop';

export const useSponsoredItemsStore = defineStore('sponsoredItems', {
  state: () => ({
    productPoolMedia: null,
    sponsoredLoading: true,
  }),
  actions: {
    async fetchSponsoredItems(data) {
      if (this.productPoolMedia !== null && this.productPoolMedia.length > 0) {
        return;
      }

      const { customerId, deviceType, category, sponosoredItemsFilter, regionCode, apiCount, uid } = data;
      const url = `${SPONSORED_ITEMS_URL}?customerId=${customerId}&category=${category}&deviceType=${deviceType}&regionCode=${regionCode}&sponosoredItemsFilter=${sponosoredItemsFilter}&apicount=${apiCount}`;

      try {
        this.sponsoredLoading = true;
        const response = await $http.get(url, {
          headers: {
            'X-Macys-ClientId': 'dealspage',
            'X-Macys-RequestId': uid,
            'x-requested-with': 'XMLHttpRequest',
          },
        });

        if (response && response.data && response.data.productPoolMedia) {
          this.productPoolMedia = response.data.productPoolMedia.collection.map((el) => ({
            id: el.product.id,
            name: el.product.detail.name,
            brand: el.product.detail.brand,
            formatedPrice: el.product.pricing.price.tieredPrice[0]?.values[0].formattedValue,
            formatedSale: el.product.pricing.price.tieredPrice[1]?.values[0].formattedValue,
            imagery: el.product.imagery.primaryImage.filePath,
            identifier: el.product.identifier,
            meta: el.product.meta,
            pricing: el.product.pricing,
          }));
        }
      } catch (error) {
        console.error('Failed to fetch sponsored items:', error);
        // Handle error appropriately
      } finally {
        this.sponsoredLoading = false;
      }
    },
    async invokeUrl(url) {
      try {
        await fetch(url);
      } catch (error) {
        console.error('Failed to invoke URL:', error);
      }
    },
  },
});
